import { Input } from "@chakra-ui/input";

export function InputUsage({ disabled, defaultValue, onChange, value }) {
  return (
    <Input
      type="text"
      disabled={disabled}
      value={value}
      minW={"100px"}
      defaultValue={defaultValue}
      onChange={onChange}
    />
  );
}
